/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PublishIcon from '@material-ui/icons/Publish';
import { Box, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { ImageAspectRatio } from 'models/forms';
import useStyles from './style';

interface Props {
  aspectRatio: ImageAspectRatio;
  onChange: ({ target }: any) => void;
}

const EmptyImage: React.FC<Props> = (props) => {
  const { aspectRatio, onChange } = props;
  const classes = useStyles();

  return (
    <div
      className={clsx({
        [classes.containerHorizontal]: aspectRatio === ImageAspectRatio.AR_9_16,
        [classes.containerVertical]: aspectRatio === ImageAspectRatio.AR_2_3,
      })}
    >
      <input
        type='file'
        accept='image/*'
        id='upload-image-button'
        className={classes.input}
        onChange={onChange}
      />
      <Box className={classes.iconContainer}>
        <PublishIcon className={classes.icon} />
      </Box>
      <label htmlFor='upload-image-button'>
        <Typography variant='body1' className={classes.title}>
          Upload Image
        </Typography>
      </label>
      <Typography variant='body2' className={classes.subtitle}>
        Any JPG, JPEG, or PNG
      </Typography>
    </div>
  );
};

export default EmptyImage;
